import { ICity, IResidence } from 'interfaces'

const DEFAULT_IMG = process.env.REACT_APP_DEFAULT_IMG!

function getResidenceMainImgUrl(residence: IResidence): string {
  if (!!residence.immagine) {
    return residence.immagine
  }
  if (!residence.immagine && !!residence.immagini && residence.immagini.length > 0) {
    return residence.immagini[0]
  }
  return DEFAULT_IMG
}

function getResidenceImgUrls(residence: IResidence): string[] {
  if (!!residence.immagini && residence.immagini.length > 0) {
    return residence.immagini
  } else if (!!residence.immagine) {
    return [residence.immagine]
  }
  return [DEFAULT_IMG]
}

function getCityMainImgUrl(city: ICity): string {
  if (!!city.immagine) {
    return city.immagine
  }

  return DEFAULT_IMG
}

export const imageService = {
  getResidenceMainImgUrl,
  getCityMainImgUrl,
  getResidenceImgUrls,
}
